@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.discountText {
    color: var(--blue-01);
    font-family: typography.$font-mont;
    font-weight: bold;
    font-size: 11px;
    background-color: var(--blue-03);
    padding: 0px 5px 0px 3px;
    width: fit-content;
    height: fit-content;
    inline-size: fit-content;
    block-size: fit-content;
    margin: 10px 0px;

    @media screen and (max-width: 991px) {
        align-items: center;
        border-radius: 2px;
        color: var(--brand-indigo);
        display: inline-flex;
        font-size: 10px;
        font-weight: 600;
        gap: 3px;
        line-height: 14px;
        margin: 4px 0 6px;
        padding: 3px 6px;

        .iconCircle {
            height: 12px;
            width: 12px;
        }
    }

    @include breakpoints.desktop {
        margin: 0px 0px 10px 0px;
    }
}
